import {
  Component,
  Input,
  HostBinding,
} from '@angular/core';

@Component({
  selector: 'bui-row-indent',
  template: ``
})
export class RowIndentComponent {
  @Input() indentSize: number;

  @HostBinding(`style.paddingLeft.px`)
  get paddingLeft() {
    return this.indentSize * 20;
  }

  @HostBinding(`class.ant-table-row-indent`) _rowIndent = true;

  constructor() {
  }
}
